/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useState, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import ImageLoad from './ImageLoad';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Search = ({ SearchRef, setIsSearch }) => {

    const { t } = useTranslation();
    const { BaseUrl } = useContext(MyContext);

    const [apiloading, setApiLoding] = useState(false);
    const [input, setInput] = useState("");
    const [searchdata, setSearchData] = useState([]);

    const navigate = useNavigate();

    const handleClose = () => {
        SearchRef.current.classList.remove('addres_menu_open');
        setTimeout(() => {
            setIsSearch(false);
        }, 500);
    };

    useEffect(() => {
        if (input) {
            const uid = secureLocalStorage.getItem("Userid") || "0";
            setApiLoding(true);
            axios.post(`${BaseUrl}tcapi/s_child_search.php`, { uid, keyword: input })
                .then((res) => {
                    setSearchData(res.data.SearchChildcatdata);
                    setApiLoding(false);
                })
                .catch((errro) => {
                    console.error("s_child_search.php", errro);
                });
        }
    }, [input]);

    const handleGetDetails = (item) => {

        navigate("/details", { state: { path: "/", name: "Home" } });

        const LocalData = {
            title: item.title,
            cid: item.category_id,
            childcat_id: item.childcat_id
        };

        secureLocalStorage.setItem("Productid", JSON.stringify(LocalData));
        setIsSearch(false);
        SearchRef.current.classList.remove('addres_menu_open');
    };


    return (
        <div className="search_box">
            <div>
                <div className="flex items-center gap-[10px]">
                    <button onClick={handleClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="#25314C" />
                        </svg>
                    </button>
                    <h1 className="font-bold text-[20px]">{t("Search Product")}</h1>
                </div>

                <div className="mt-[15px] flex items-center">
                    <input type="text" value={input} onChange={(e) => setInput(e.target.value)} className="border-[2px] font-[600] text-[17px] w-full rounded-[10px] py-[8px] px-[10px]" placeholder={t("Search for product...")} />
                    <svg width="22" height="22" className="-ms-[35px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="#25314C" />
                    </svg>
                </div>

            </div>

            <div className="h-full scroll_container mt-[20px]">
                {apiloading
                    ? <div className="h-full flex items-center justify-center">
                        <div className="loader mx-auto"></div>
                    </div>
                    : <div className="h-full">
                        {searchdata.length >= 1
                            ? searchdata.map((item, index) => {
                                return <div key={index} onClick={() => handleGetDetails(item)} className="search_card">
                                    <ImageLoad BaseUrl={BaseUrl} url={item.img} CustomeStyle={"w-[50px]"} />
                                    <h1 className="font-[600] text-[17px] text-gray-800">{item.title}</h1>
                                </div>
                            })
                            : (input && <div className="h-full flex items-center justify-center">
                                <h1 className="font-[600] text-[20px] text-gray-800">{t("No search data found !!")}</h1>
                            </div>)
                        }
                    </div>}
            </div>


        </div>
    )
}

export default Search
/* jshint ignore:end */